.container {
    display: grid;
    grid-template-columns: 225px 1fr;
    gap: 24px;
    padding: 16px;
    width: 100%;
    box-sizing: border-box;
}
